export default {
  name: 'NrLoadingAnimation',
  props: {
    animated: {
      type: Boolean,
      default: true
    },
    count: {
      type: Number,
      default: 1
    }
  }
};